<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-layout align-center justify-center>
              <v-flex xs10 sm8 md8>
                <img src="@/assets/Logo_Full_Green_Trans.png" style="width:100%;padding-bottom:40px"/>
              </v-flex>
            </v-layout>
            <v-alert v-if="message" :value="true" type="warning">
              {{ message }}
            </v-alert>
            <v-card class="elevation-12">
              <v-form v-model="formValid" ref="loginForm" @submit.prevent="login">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Login</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-text-field prepend-icon="person" name="username" label="Username" type="text" v-model="auth.username" :rules="[formRules.usernameRequired]"></v-text-field>
                    <v-text-field prepend-icon="lock" name="password" label="Password" type="password" v-model="auth.password" :rules="[formRules.passwordRequired, formRules.checkCredentials]"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" type="submit">Login</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      formValid: false,
      credentialsValid: true,
      formRules: {
        usernameRequired: value => !!value || 'Please enter your username.',
        passwordRequired: value => !!value || 'Please enter your password.',
        checkCredentials: value => (value && this.credentialsValid) || 'The username and password you entered are invalid.'
      },
      auth: {
        username: '',
        password: ''
      },
      message: this.$route.query.message
    }
  },
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  methods: {
    login () {
      // Initial assumption is the credentials will be valid.
      this.credentialsValid = true
      // Validate the form.
      this.$refs.loginForm.validate()
      if (this.formValid) {
        // Send an empty payload {} with Basic Auth Headers.
        this.$http.post('/user/tokens', {}, { auth: { username: this.auth.username, password: this.auth.password } })
          .then(request => this.loginSuccessful(request))
          .catch(() => this.loginFailed())
      }
    },
    loginSuccessful (request) {
      // Ensure a valid token was returned.
      if (!request.data.token || request.data.error) {
        this.loginFailed()
        return
      }
      // Run the Vuex login action.
      this.$store.dispatch('login', request.data.token)
      // Redirect to the home.
      this.$router.push(this.$route.query.redirect || '/home')
    },
    loginFailed () {
      this.credentialsValid = false
      this.$store.dispatch('logout')
      // Validate the form. (Essentially displays the Invalid error.)
      this.$refs.loginForm.validate()
    },
    checkCurrentLogin () {
      // If the user is logged in then redirect to home.
      if (this.currentUser) {
        this.$router.push(this.$route.query.redirect || '/home')
      }
    }
  },
  updated () {
    this.checkCurrentLogin()
  },
  beforeMount () {
    this.checkCurrentLogin()
  }
}
</script>

<style>
#login {
  animation: fadein 0.6s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>
